var _circle, _circle2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatientIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    stroke: "#AEB5FF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_483_3765",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "#D9D9D9",
    stroke: "#AEB5FF",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_483_3765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1177 26.6788C26.9723 25.2561 25.8823 24.0898 24.3561 24.0898H19.7051C19.5274 24.6771 18.179 25.1321 16.9597 25.1321C15.7404 25.1321 14.4081 24.6771 14.2304 24.0898H9.64398C8.11786 24.0898 7.02777 25.2561 6.88242 26.6788C6.75323 27.903 6.11532 30.3183 6.00228 31.5424C5.87308 32.9651 11.267 34.9999 16.9516 34.9999C23.1207 34.9999 28.119 32.9651 27.9978 31.5424C27.8848 30.31 27.2469 27.903 27.1177 26.6788V26.6788Z",
    stroke: "#AEB5FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9418 15.752C21.4573 19.0109 19.366 21.4675 16.8628 21.4675C14.3596 21.4675 12.349 19.1102 11.8161 15.9422",
    stroke: "#AEB5FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9112 6.00827C16.9112 6.00827 16.887 6.00827 16.8709 6.00827C16.8709 6.00827 16.8628 6.00827 16.8547 6.00827C16.8466 6.00827 16.8466 6.00827 16.8386 6.00827C16.8305 6.00827 16.8224 6.00827 16.8143 6.00827C12.018 6.04136 10.5968 9.75525 10.5968 13.7586C10.5968 14.8174 11.267 15.5618 11.6788 15.9175C11.8565 16.0747 11.9857 16.1491 11.9857 16.1491C12.4782 15.8017 16.3056 12.7247 18.5504 10.905L21.7238 16.1491C21.7238 16.1491 23.1126 15.2806 23.1126 13.7504C23.1126 9.74698 21.6996 6.04136 16.9112 6V6.00827Z",
    stroke: "#AEB5FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1497 20.4172V24.3462",
    stroke: "#AEB5FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7616 20.4172V24.3462",
    stroke: "#AEB5FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientIcon);
export default __webpack_public_path__ + "static/media/patient-icon.3315c6f68279752e4c6e1b66b9158339.svg";
export { ForwardRef as ReactComponent };